import styled from "styled-components";
import { media } from "../../../../utils";

export const ImageContent = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 26px;
  ${media.md()} {
    display: none;
  }
`;

export const DenunciaButton = styled.button`
  width: 100%;
  ${media.md()} {
    width: auto;
  }
`;

export const SectionInfo = styled.div(({ theme }) => ({
  margin: "20px 0",
  [`&+&`]: {
    borderTop: `1px solid ${theme.color.neutral["05"]}`,
    padding: "20px 0",
  },
}));
